import { Injectable } from "@youm-api/common/injector/adapter";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class NoticeFeatureNoticeService {
  private readonly _isRenderable$ = new BehaviorSubject<boolean>(true);

  get isRenderable$() {
    return this._isRenderable$.asObservable();
  }

  isRenderableSet(isRenderable: boolean) {
    this._isRenderable$.next(isRenderable);
  }
}
